import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Monitor, Trash2, Edit, Film } from "lucide-react";

interface ScreenCardProps {
  screen: {
    id: string;
    name: string;
    settings?: {
      description?: string;
    };
    created_at: string;
  };
  mediasCount: number;
  onDelete: (id: string) => void;
  onEdit: (screen: any) => void;
}

const ScreenCard = ({ screen, onDelete, onEdit, mediasCount }: ScreenCardProps) => {
  return (
    <Card className="border border-gray-200 hover:shadow-md transition-shadow bg-[#f3f9f3]">
      <CardContent className="p-4">
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-start space-x-3 flex-1 min-w-0">
            <div className="p-2 bg-green-100/80 rounded-lg flex-shrink-0">
              <Monitor className="h-4 w-4 text-green-600" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-medium text-gray-800 truncate" title={screen.name}>
                {screen.name}
              </h3>
              <p className="text-sm text-gray-600 mt-1 truncate" title={screen.settings?.description}>
                {screen.settings?.description || "Sem descrição"}
              </p>
              <div className="flex items-center text-xs text-gray-500 mt-2">
                <Film className="h-3 w-3 mr-1.5 text-gray-500" />
                <span>{mediasCount} {mediasCount === 1 ? 'mídia' : 'mídias'}</span>
              </div>
              <p className="text-xs text-gray-400 mt-2">
                Criado em {new Date(screen.created_at).toLocaleDateString()}
              </p>
            </div>
          </div>
          <div className="flex space-x-1">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onEdit(screen)}
              className="text-gray-600 hover:text-[#39b92c] hover:bg-green-50"
            >
              <Edit className="h-3 w-3" />
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onDelete(screen.id)}
              className="text-gray-600 hover:text-destructive hover:bg-red-50"
            >
              <Trash2 className="h-3 w-3" />
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ScreenCard;
